import "unicode-segmenter/intl-polyfill";
export { default as stringLength } from "string-length";
